import React, { useState } from "react";
import { useForm } from "react-hook-form";
import { Link, useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import { addRetailer } from "../../services/retailer.service";
import { useSelector } from "react-redux";

export default function RetailerAdd() {
  const { token } = useSelector((state) => state?.auth);
  const [isLoading2, setIsLoading2] = useState(false);
  const navigate = useNavigate();

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm();

  const onSubmit = async (item) => {
    setIsLoading2(true);
  
    const data = {
      email: item.retailerEmail,
      mobile_number: item.retailerContact,
      password: null,
      shop_name: item.shopName,
      PAN_number: item.panNumber,
      GST_number: item.gstNumber,
      owner_name: item.ownerName,
      address: item.retailerAddress,
      role: "Retailer",
    };
  
    try {
      const res = await addRetailer(token, data);
  
      if (res && res.status >= 200 && res.status <= 202) {
        Swal.fire({
          title: "Added!",
          text: `${item.ownerName} Retailer has been added.`,
          icon: "success",
          confirmButtonText: "OK",
        }).then(() => {
          navigate("/retailer");
        });
      } else if (res && res.status >= 400 && res.status < 500) {
        const emailError = res?.data?.email ? `${res?.data?.email}<br>` : "";
        const mobileError = res?.data?.mobile_number
          ? `${res?.data?.mobile_number}`
          : "";
        Swal.fire("Error", `${emailError}${mobileError}`, "error");
      } else {
        Swal.fire(
          "Error",
          res?.data?.error || "An unexpected error occurred. Please try again later.",
          "error"
        );
      }
    } catch (error) {
      console.error("Error during adding retailer:", error);
      Swal.fire(
        "Error",
        "An error occurred. Please try again later.",
        "error"
      );
    } finally {
      setIsLoading2(false);
    }
  };
  
  return (
    <div className="content-body">
      <div className="container-fluid">
        <div className="row">
          <div className="col-xl-12 col-lg-12">
            <div className="card">
              <div className="card-header">
                <h4 className="card-title">Add Retailer</h4>
                <Link to="/retailer">
                  <img src="/assets/images/kidskart/icon/back-button.png" />
                </Link>{" "}
              </div>
              <div className="card-body py-3">
                <div className="basic-form">
                  <form onSubmit={handleSubmit(onSubmit)}>
                    <div className="row">
                      {/* shop Name */}
                      <div className="mb-4 col-md-6">
                        <div className="d-flex">
                          <label className="form-label">Shop Name</label>
                          <i class="fa-solid fa-asterisk asterisk ms-1 mt-1"></i>
                        </div>
                        <input
                          type="text"
                          className="form-control"
                          placeholder="Enter shop name"
                          maxLength={30}
                          {...register("shopName", {
                            required: "Shop name is required",
                          })}
                        />
                        {errors.shopName && (
                          <p className="error">{errors.shopName.message}</p>
                        )}
                      </div>

                      {/* Retailer Name */}
                      <div className="mb-4 col-md-6">
                        <div className="d-flex">
                          <label className="form-label">Retailer Name</label>
                          <i class="fa-solid fa-asterisk asterisk ms-1 mt-1"></i>
                        </div>
                        <input
                          type="text"
                          className="form-control"
                          placeholder="Enter Retailer name"
                          maxLength={30}
                          {...register("ownerName", {
                            required: "Retailer name is required",
                          })}
                        />
                        {errors.ownerName && (
                          <p className="error">{errors.ownerName.message}</p>
                        )}
                      </div>

                      {/* Retailer Email */}
                      <div className="mb-4 col-md-6">
                        <div className="d-flex">
                          <label className="form-label">Retailer Email</label>
                          <i class="fa-solid fa-asterisk asterisk ms-1 mt-1"></i>
                        </div>
                        <input
                          type="text"
                          className="form-control"
                          placeholder="Enter retailer email"
                          maxLength={50}
                          {...register("retailerEmail", {
                            required: "Email is required",
                            pattern: {
                              value: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
                              message: "Enter a valid email address",
                            },
                          })}
                        />
                        {errors.retailerEmail && (
                          <p className="error">
                            {errors.retailerEmail.message}
                          </p>
                        )}
                      </div>

                      {/* Retailer Contact */}
                      <div className="mb-4 col-md-6">
                        <div className="d-flex">
                          <label className="form-label">Contact Number</label>
                          <i class="fa-solid fa-asterisk asterisk ms-1 mt-1"></i>
                        </div>
                        <input
                          type="tel"
                          className="form-control"
                          placeholder="Enter contact number"
                          maxLength={10}
                          {...register("retailerContact", {
                            required: "Contact number is required",
                            pattern: {
                              value: /^[1-9][0-9]{9}$/,
                              message:
                                "Contact number must be 10 digits and not start with 0",
                            },
                          })}
                          onInput={(e) =>
                          (e.target.value = e.target.value.replace(
                            /[^0-9]/g,
                            ""
                          ))
                          }
                        />
                        {errors.retailerContact && (
                          <p className="error">
                            {errors.retailerContact.message}
                          </p>
                        )}
                      </div>
                      {/* PAN Number */}
                      <div className="mb-4 col-md-6">
                        <label className="form-label">PAN Number</label>
                        <input
                          type="text"
                          className="form-control"
                          placeholder="Enter PAN Number"
                          maxLength={30}
                          {...register("panNumber", {
                            pattern: {
                              // value: panRegex,
                              message: "Please enter a valid PAN number",
                            },
                          })}
                        />
                        {errors.panNumber && (
                          <p className="error">{errors.panNumber.message}</p>
                        )}
                      </div>
                      {/* GST Number */}
                      <div className="mb-4 col-md-6">
                        <label className="form-label">GST Number</label>
                        <input
                          type="text"
                          className="form-control"
                          placeholder="Enter GST Number"
                          maxLength={30}
                          {...register("gstNumber")}
                        />
                      </div>

                      {/* Retailer Address */}
                      <div className="mb-4 col-md-6">
                        <div className="d-flex">
                          <label className="form-label">Retailer Address</label>
                          <i class="fa-solid fa-asterisk asterisk ms-1 mt-1"></i>
                        </div>
                        <textarea
                          type="text"
                          className="form-control"
                          placeholder="Enter retailer address"
                          maxLength={200}
                          {...register("retailerAddress", {
                            required: "Address is required",
                          })}
                        />
                        {errors.retailerAddress && (
                          <p className="error">
                            {errors.retailerAddress.message}
                          </p>
                        )}
                      </div>

                      {/* Status */}
                      {/* <div className="mb-4 col-md-6">
                        <label className="form-label">Status</label>
                        <select
                          className="form-control custom-select dropdown-arrow"
                          {...register("status", {
                            required: "Status is required",
                          })}
                        >
                          <option value="">Select status</option>
                          <option value="active">Active</option>
                          <option value="inactive">Inactive</option>
                        </select>
                        {errors.status && (
                          <p className="error">{errors.status.message}</p>
                        )}
                      </div> */}
                    </div>

                    {!isLoading2 ? (
                      <div className="col-sm-4">
                        <button type="submit" className="btn btn-primary w-100">
                          ADD RETAILER
                        </button>
                      </div>
                    ) : (
                      <div className="col-sm-4">
                        <button
                          type="button"
                          className="btn btn-primary w-100"
                          disabled
                        >
                          ADDING RETAILER
                        </button>

                        <div
                          className="spinner-border2 text-primary"
                          role="status"
                        >
                          <span className="visually-hidden">Loading...</span>
                        </div>
                      </div>
                    )}
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
